import { getActiveTournament } from './activeTournament';
import { showTournamentDialog, hideTournamentDialog, redirectTournamentGame } from './Tournament.service.impl';

interface ITournament {
  getActiveTournament: typeof getActiveTournament;
  showTournamentDialog: typeof showTournamentDialog;
  hideTournamentDialog: typeof hideTournamentDialog;
  redirectTournamentGame: typeof redirectTournamentGame;
}

/**
 * @namespace
 */
const Tournament: ITournament = {
  getActiveTournament,
  showTournamentDialog,
  hideTournamentDialog,
  redirectTournamentGame,
};

export default Tournament;
